import { useState, useContext, useEffect } from "react";
import UserContext from "../../contexts/UserContext";
import ContactSheet from "./ContactSheet";
import UsageRight from "./UsageRight";
import Uploading from "../Uploading";
import _ from "lodash";
import axios from "axios";
import Utils from "../../Utils";
import Swal from "sweetalert2";

const FinalDocumentTab = (props) => {
  const [downloadCS, setDownloadCS] = useState(false);
  const [downloadUR, setDownloadUR] = useState(false);
  const { photoshootDetails } = props;
  const { userData } = useContext(UserContext);
  const [finalDocs, setFinalDocs] = useState([]);
  const [uploading, setUploading] = useState([false, false, false]); // 1 : Usage Rights , 2:  HighRes, 3: Contact Sheet
  useEffect(() => {
    if (_.get(props, "finalDocs", []).length > 0) {
      setFinalDocs(props.finalDocs);
    }
  }, [props.finalDocs]);

  const getFinalDocs = (ftype) =>
    _.find(finalDocs, (f) => f.filetype === ftype);

  const syncUploading = (type, value) => {
    let _uploading = [...uploading];
    _.set(_uploading, type - 1, value);
    setUploading(_uploading);
  };

  const onHandleSubmit = (e) => {
    e.preventDefault();
    let type = e.target.type.value;

    const formData = new FormData();
    formData.append("type", "fd");
    formData.append("psid", photoshootDetails.id);

    if (type === "highres") {
      formData.append("highres", e.target.highres.files[0]);
      type = 2;
    }
    if (type === "contactsheet") {
      formData.append("contactsheet", e.target.contactsheet.files[0]);
      type = 3;
    }
    if (type === "usageright") {
      formData.append("usageright", e.target.usageright.files[0]);
      type = 1;
    }

    syncUploading(type, true);

    // Show loading popup
    Swal.fire({
      title: "Uploading...",
      text: "Please wait while file is uploading",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    axios
      .post(Utils.apiUrl("photoshoot/fd-upload"), formData, {
        headers: {
          ...Utils.apiHeaders().headers,
        },
      })
      .then((res) => {
        Swal.close(); // close loader

        if (res.data.success) {
          Swal.fire({
            title: "Success",
            text: res.data.message || "File uploaded successfully",
            icon: "success",
            confirmButtonText: "OK",
          }).then(() => {
            if (_.get(res.data, "status", 0) > 0) {
              window.location.reload();
            } else {
              setFinalDocs(res.data.data);
            }
          });
        } else {
          Swal.fire({
            title: "Failed",
            text: res.data.message || "Upload failed",
            icon: "error",
          });
        }
      })
      .catch((err) => {
        console.error(err);
        Swal.close();

        Swal.fire({
          title: "Error",
          text: err?.response?.data?.message || "Upload failed",
          icon: "error",
        });
      })
      .finally(() => {
        syncUploading(type, false);
      });
  };

  const handleDownload = (url, label) => {
    Swal.fire({
      title: `Download ${label}`,
      text: `Do you want to download the ${label}?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Download",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        Swal.fire({
          title: "Downloading...",
          text: `${label} download has started.`,
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        });
      }
    });
  };

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {/* High Res Upload Card */}
        <div className="max-w-md w-full mx-auto bg-white rounded-xl shadow-md overflow-hidden border border-gray-200 p-4 flex flex-col items-center">
          <h3 className="text-xl font-bold text-gray-800 mb-2">
            High Resolution Package
          </h3>
          {uploading[1] && <Uploading />}
          {uploading[1] === false && (
            <>
              {getFinalDocs(2) && (
                <div className="bg-green-100 text-green-800 w-full mb-4 p-4 rounded">
                  <i className="fas fa-check-circle mr-2"></i> High Resolution
                  file uploaded successfully.
                  <div className="w-full text-center my-3">
                    {/* <a
                      href={getFinalDocs(2).filename}
                      download
                      className="items-center px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded hover:bg-blue-700 transition"
                    >
                      High Resolution Zip <i className="fas fa-download mr-2"></i>
                    </a>*/}
                    <button
                      onClick={() =>
                        handleDownload(
                          getFinalDocs(2).filename,
                          "High Resolution Zip",
                        )
                      }
                      className="items-center px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded hover:bg-blue-700 transition"
                    >
                      High Resolution Zip{" "}
                      <i className="fas fa-download mr-2"></i>
                    </button>
                  </div>
                </div>
              )}
              {!getFinalDocs(2) && (
                <form onSubmit={onHandleSubmit}>
                  <input type="hidden" name="type" value="highres" />
                  <div className="w-full flex flex-col items-center mt-8">
                    <label
                      className="block text-gray-700 font-medium mb-2"
                      htmlFor="highres-upload"
                    >
                      Upload High Resolution file (ZIP only)
                    </label>
                    <input
                      id="highres-upload"
                      type="file"
                      required
                      name="highres"
                      accept=".zip"
                      className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
                    />
                  </div>
                  <div className="w-full flex justify-center mt-2">
                    <button
                      type="submit"
                      className="mb-4 inline-flex items-center px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded hover:bg-blue-700 transition"
                    >
                      Upload
                    </button>
                  </div>
                </form>
              )}
            </>
          )}
        </div>
        {/* Contact Sheet Card */}
        <div className="max-w-md w-full mx-auto bg-white rounded-xl shadow-md overflow-hidden border border-gray-200 p-4 flex flex-col items-center">
          <h3 className="text-xl font-bold text-gray-800 mb-2">
            Contact Sheet
          </h3>
          {uploading[2] && <Uploading />}
          {uploading[2] === false && (
            <>
              {getFinalDocs(3) && (
                <div className="bg-green-100 text-green-800 w-full mb-4 p-4 rounded">
                  <i className="fas fa-check-circle mr-2"></i> Contact Sheet
                  file uploaded successfully.
                  <div className="w-full text-center my-3">
                    {/* <a
                      href={getFinalDocs(3).filename}
                      download
                      className="items-center px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded hover:bg-blue-700 transition"
                    >
                      Contact Sheet <i className="fas fa-download mr-2"></i>
                    </a>*/}
                    <button
                      onClick={() =>
                        handleDownload(
                          getFinalDocs(3).filename,
                          "Contact Sheet",
                        )
                      }
                      className="items-center px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded hover:bg-blue-700 transition"
                    >
                      Contact Sheet <i className="fas fa-download mr-2"></i>
                    </button>
                  </div>
                </div>
              )}
              {!getFinalDocs(3) && (
                <>
                  {_.get(props, "photoshootImages", []).length > 0 && (
                    <button
                      onClick={() => setDownloadCS(true)}
                      className="mb-4 inline-flex items-center px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded hover:bg-blue-700 transition"
                    >
                      <i className="fas fa-download mr-2"></i> Download Sample
                    </button>
                  )}
                  <form onSubmit={onHandleSubmit}>
                    <input type="hidden" name="type" value="contactsheet" />
                    <div className="w-full flex flex-col items-center">
                      <label
                        className="block text-gray-700 font-medium mb-2"
                        htmlFor="contact-sheet-upload"
                      >
                        Upload Signed Final Document (PDF/DOCX)
                      </label>
                      <input
                        id="contact-sheet-upload"
                        type="file"
                        required
                        name="contactsheet"
                        accept=".pdf,.doc,.docx"
                        className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
                      />
                    </div>
                    <div className="w-full flex justify-center mt-2">
                      <button
                        type="submit"
                        className="mb-4 inline-flex items-center px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded hover:bg-blue-700 transition"
                      >
                        Upload
                      </button>
                    </div>
                  </form>
                </>
              )}
            </>
          )}
        </div>
        {/* Usage Rights Card */}
        <div className="max-w-md w-full mx-auto bg-white rounded-xl shadow-md overflow-hidden border border-gray-200 p-4 flex flex-col items-center">
          <h3 className="text-xl font-bold text-gray-800 mb-2">Usage Rights</h3>
          {uploading[0] && <Uploading />}
          {uploading[0] === false && (
            <>
              {getFinalDocs(1) && (
                <div className="bg-green-100 text-green-800 w-full mb-4 p-4 rounded">
                  <i className="fas fa-check-circle mr-2"></i> Usage Rights file
                  uploaded successfully.
                  <div className="w-full text-center my-3">
                    <button
                      onClick={() =>
                        handleDownload(getFinalDocs(1).filename, "Usage Rights")
                      }
                      className="items-center px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded hover:bg-blue-700 transition"
                    >
                      Usage Rights <i className="fas fa-download mr-2"></i>
                    </button>
                  </div>
                </div>
              )}
              {!getFinalDocs(1) && (
                <>
                  <button
                    onClick={() => setDownloadUR(true)}
                    className="mb-4 inline-flex items-center px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded hover:bg-blue-700 transition"
                  >
                    <i className="fas fa-download mr-2"></i> Download Sample
                  </button>
                  <form onSubmit={onHandleSubmit}>
                    <input type="hidden" name="type" value="usageright" />
                    <div className="w-full flex flex-col items-center">
                      <label
                        className="block text-gray-700 font-medium mb-2"
                        htmlFor="usage-rights-upload"
                      >
                        Sign and Upload Final Document (PDF/DOCX)
                      </label>
                      <input
                        id="usage-rights-upload"
                        type="file"
                        required
                        name="usageright"
                        accept=".pdf,.doc,.docx"
                        className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
                      />
                    </div>
                    <div className="w-full flex justify-center mt-2">
                      <button
                        type="submit"
                        className="mb-4 inline-flex items-center px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded hover:bg-blue-700 transition"
                      >
                        Upload
                      </button>
                    </div>
                  </form>
                </>
              )}
            </>
          )}
        </div>
      </div>

      {downloadCS && (
        <ContactSheet
          photoshootDetails={photoshootDetails}
          photoshootImages={_.get(props, "photoshootImages", [])}
          onLoad={props.onLoad}
          resetDownload={() => setDownloadCS(false)}
        />
      )}
      {downloadUR && (
        <UsageRight
          photoshootDetails={photoshootDetails}
          photoshootImages={_.get(props, "photoshootImages", [])}
          onLoad={props.onLoad}
          resetDownload={() => setDownloadUR(false)}
        />
      )}
    </>
  );
};

export default FinalDocumentTab;
